import { PDFDocument, degrees, rgb } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'
import { useState } from "react"
import moment from "moment";
import constant from '../../../constant';

interface IPropType {
    detail: {
        loanId: any,
        borrowerName: any, borrowerEmail: any, borrowerSignature: any, borrowerSignatureDate: any,
        transactionNumber: any, transactionAmount: any, ctcDate: any, broker: any,
        coBorrowerName: any, coBorrowerEmail: any, coBorrowerSignature: any, coBorrowerSignatureDate: any,
        borrowerAddress: any,
        propertyAddress: any,
        // lenderName: any,
    }
}

function HeterIskaPDF(props: IPropType) {
    const { detail } = props;
    const [stateDetail, setStateDetail]: any = useState(null);
    const [docURLs, setDocURLs]: any = useState(null);

    if (JSON.stringify(detail) !== JSON.stringify(stateDetail)) {
        generateBlobs(detail).then((res: any[]) => {
            const _docURLs = res.map((blob: Blob) => URL.createObjectURL(blob));
            setDocURLs(_docURLs);
        })
        setStateDetail(detail);
    }

    if (docURLs && docURLs.length > 0) {
        return (
            <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                <iframe
                    title="Heter Iska - Power Express"
                    style={{ width: '100%', height: '50%' }}
                    src={docURLs[0]}
                />
                {
                    docURLs[1] &&
                    <iframe
                        title="Heter Iska - Power Express (Short)"
                        style={{ width: '100%', height: '50%' }}
                        src={docURLs[1]}
                    />
                }
            </div>
        )
    }
    return <div>Loading...</div>
}

export async function generateBlob(detail: any) {
    const mDateToCompare = moment('2024-10-20');
    const mCTCDate = moment(detail.ctcDate)
    // if (mCTCDate.isSameOrAfter(mDateToCompare)) {
    return generateBlob2(detail);
    // } else {
    //     return generateBlob1(detail);
    // }
}

export async function generateBlob1(detail: any) {
    const fontURL = '/fonts/calibril.ttf'
    const fontBytes = await fetch(fontURL).then(res => res.arrayBuffer())

    const url = `${process.env.REACT_APP_BASE_URL}/heter-iska/power-express.pdf`;
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    pdfDoc.registerFontkit(fontkit)
    const customFont = await pdfDoc.embedFont(fontBytes)
    console.log(detail);
    const pages = pdfDoc.getPages();
    const fontSize = 12;
    //#region page 1
    const { height, width } = pages[2].getSize()
    // pages[2].drawText(
    //     parseFloat(detail.transactionAmount).toLocaleString(undefined, { minimumFractionDigits: 0 }),
    //     {
    //         rotate: degrees(-90),
    //         x: height - 10,
    //         y: width - 365,
    //         size: fontSize,
    //         font: customFont,
    //     });

    // date
    const _ctcDate = detail.ctcDate ? moment(detail.ctcDate) : moment();
    pages[2].drawText(
        _ctcDate.format(constant.formatting.usDateFormat),
        {
            rotate: degrees(-90),
            x: height - 12,
            y: width - 365,
            size: fontSize,
            font: customFont,
        });
    // // receiver name
    pages[2].drawText(detail.borrowerName,
        {
            rotate: degrees(-90),
            x: height - 26,
            y: width - 365,
            size: fontSize,
            font: customFont,
        });

    pages[2].drawText(detail.borrowerAddress ? detail.borrowerAddress : '',
        {
            rotate: degrees(-90),
            x: height - 38,
            y: width - 365,
            size: fontSize,
            font: customFont,
        });
    // // receiver address

    // // loan id
    pages[2].drawText(detail.loanId + " " + detail.bankReferenceNumber,
        {
            rotate: degrees(-90),
            x: height - 52,
            y: width - 365,
            size: fontSize,
            font: customFont,
        });

    pages[2].drawRectangle({
        rotate: degrees(-90),
        x: height - 66,
        y: width - 284,

        width: 28,
        height: 10,
        borderWidth: 0,
        // borderColor: grayscale(0.5),
        // color: rgb(0.75, 0.2, 0.2),e8e8e8
        color: rgb(0.9098039215686274, 0.9098039215686274, 0.9098039215686274),
        opacity: 1,
        // borderOpacity: 0.75,
    })
    pages[2].drawText("Amount:",
        {
            rotate: degrees(-90),
            x: height - 64.5,
            y: width - 285,
            size: 9.5,
            // font: customFont,
        });

    pages[2].drawText(parseFloat(detail.transactionAmount).toLocaleString(undefined, { minimumFractionDigits: 0 }),
        {
            rotate: degrees(-90),
            x: height - 64,
            y: width - 365,
            size: fontSize,
            font: customFont,
        });
    // // loan date
    // pages[0].drawText('You can modify PDFs too!');
    //#endregion

    //#region page 8
    // borrowerSignature: any, borrowerSignatureDate: any,
    if (detail.borrowerSignature) {
        const pngImageBytes = await fetch(detail.borrowerSignature).then((res) => res.arrayBuffer());
        const pngImage = await pdfDoc.embedPng(pngImageBytes)
        const pngDims = pngImage.scale(0.25)
        pages[6].drawImage(pngImage, {
            rotate: degrees(-90),
            x: height - 190,
            y: width - 260,

            width: pngDims.width,
            height: pngDims.height,
        })
    }
    if (detail.borrowerSignatureDate) {
        const md = moment(detail.borrowerSignatureDate);
        pages[6].drawText(md.format('DD'), {
            rotate: degrees(-90),
            x: height - 190,
            y: width - 480,
            size: fontSize, font: customFont,
        });
        pages[6].drawText(md.format('MMM'), {
            rotate: degrees(-90),
            x: height - 190,
            y: width - 500,
            size: fontSize, font: customFont,
        });
        pages[6].drawText(md.format('YYYY'), {
            rotate: degrees(-90),
            x: height - 190,
            y: width - 530,
            size: fontSize, font: customFont,
        });
    }
    // coBorrowerSignature, coBorrowerSignatureDate
    // pages[6].drawText(detail.borrowerName, {
    //     x: 63, y: (height - 433), size: fontSize, font: customFont,
    // });
    pages[6].drawText(detail.coBorrowerName, {
        // x: 315, y: (height - 433),
        rotate: degrees(-90),
        x: height - 280,
        y: width - 260,
        size: fontSize, font: customFont,
    });

    if (detail.coBorrowerSignature) {
        const pngImageBytes = await fetch(detail.coBorrowerSignature).then((res) => res.arrayBuffer());
        const pngImage = await pdfDoc.embedPng(pngImageBytes);
        const pngDims = pngImage.scale(0.25)
        pages[6].drawImage(pngImage, {
            rotate: degrees(-90),
            x: height - 320,
            y: width - 260,
            // x: 311,
            // y: pages[6].getHeight() - 387,
            width: pngDims.width,
            height: pngDims.height,
        })
    }

    if (detail.coBorrowerSignatureDate) {
        const md = moment(detail.coBorrowerSignatureDate);
        pages[6].drawText(md.format('DD'), {
            rotate: degrees(-90),
            x: height - 320,
            y: width - 478,
            size: fontSize, font: customFont,
        });
        pages[6].drawText(md.format('MMM'), {
            rotate: degrees(-90),
            x: height - 320,
            y: width - 498,
            size: fontSize, font: customFont,
        });
        pages[6].drawText(md.format('YYYY'), {
            rotate: degrees(-90),
            x: height - 320,
            y: width - 528,
            size: fontSize, font: customFont,
        });
    }
    //#endregion

    // pdfDoc.removePage(0);
    // pdfDoc.removePage(1);
    // pdfDoc.removePage(2);
    // pdfDoc.removePage(3);
    const pdfBytes = await pdfDoc.save();

    const bytes = new Uint8Array(pdfBytes);
    const blob = new Blob([bytes], { type: "application/pdf" });
    return Promise.resolve(blob);
}

/*
  * Using font.widthOfTextAtSize transform text adding \n to break lines
  * if width of text is bigger than the width passed as parameter
  * and return the text with the line breaks
  * @param text: string
  * @param width: number
  * @param font: font
  * @param fontSize: number
  * @returns string
  */
const wrapText = (text: any, width: any, font: any, fontSize: any) => {
    const words = text.split(' ');
    let line = '';
    let result = '';
    for (let n = 0; n < words.length; n++) {
        const testLine = line + words[n] + ' ';
        const testWidth = font.widthOfTextAtSize(testLine, fontSize);
        if (testWidth > width) {
            result += line + '\n';
            line = words[n] + ' ';
        } else {
            line = testLine;
        }
    }
    result += line;
    return result;
}

export async function generateBlob2(detail: any) {
    const fontURL = '/fonts/calibril.ttf'
    const fontBytes = await fetch(fontURL).then(res => res.arrayBuffer())

    let url = `${process.env.REACT_APP_BASE_URL}/heter-iska/power-express-2.pdf`;

    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    pdfDoc.registerFontkit(fontkit)
    const customFont = await pdfDoc.embedFont(fontBytes)

    const pages = pdfDoc.getPages();
    const fontSize = 10;
    //#region page 1
    const { height, width } = pages[0].getSize()
    pages[0].drawRectangle({
        // rotate: degrees(-90),
        x: width - 230,
        y: height - 730,

        width: 180,
        height: 40,
        borderWidth: 0,
        // borderColor: grayscale(0.5),
        color: rgb(1, 1, 1),//e8e8e8
        // color: rgb(0.9098039215686274, 0.9098039215686274, 0.9098039215686274),
        opacity: 1,
        // borderOpacity: 0.75,
    })

    pages[0].drawText(detail.borrowerName + ': ___________________',
        {
            x: width - 230,
            y: height - 698,
            size: fontSize,
            font: customFont,
        });

    if (detail.borrowerSignature) {
        const pngImageBytes = await fetch(detail.borrowerSignature).then((res) => res.arrayBuffer());
        const pngImage = await pdfDoc.embedPng(pngImageBytes)
        const pngDims = pngImage.scale(0.25)
        pages[0].drawImage(pngImage, {
            x: width - 140,
            y: height - 698,

            width: pngDims.width,
            height: pngDims.height,
        })
    }
    if (detail.borrowerSignatureDate) {
        const md = moment(detail.borrowerSignatureDate);
        pages[0].drawText('Date: ' + md.format('DD MMM YYYY'), {
            x: width - 230,
            y: height - 718,
            size: fontSize,
            font: customFont,
        });
    }
    if (detail.coBorrowerName) {
        pages[0].drawText(detail.coBorrowerName + ': ___________________',
            {
                x: width - 262,
                y: height - 738,
                size: fontSize,
                font: customFont,
            });
        if (detail.coBorrowerSignature) {
            const pngImageBytes = await fetch(detail.coBorrowerSignature).then((res) => res.arrayBuffer());
            const pngImage = await pdfDoc.embedPng(pngImageBytes)
            const pngDims = pngImage.scale(0.25)
            pages[0].drawImage(pngImage, {
                x: width - 140,
                y: height - 738,

                width: pngDims.width,
                height: pngDims.height,
            })
        }
        if (detail.coBorrowerSignatureDate) {
            const md = moment(detail.coBorrowerSignatureDate);
            pages[0].drawText('Date: ' + md.format('DD MMM YYYY'), {
                x: width - 230,
                y: height - 758,
                size: fontSize,
                font: customFont,
            });
        }
    }

    pages[0].drawRectangle({
        // rotate: degrees(-90),
        x: width - 295,
        y: height - 680,

        width: 254,
        height: 20,
        borderWidth: 0,
        // borderColor: grayscale(0.5),
        color: rgb(1, 1, 1),//e8e8e8
        // color: rgb(0.9098039215686274, 0.9098039215686274, 0.9098039215686274),
        opacity: 1,
        // borderOpacity: 0.75,
    })
    console.log(detail);
    // const text = `NY, on the date of July 31st, 2024, for 1722 45th St, Brooklyn NY 11204, and all is valid and in good standing.`
    const text = `NY, on the date of ${moment(detail.ctcDate, 'YYYY-MM-DD').format('MMMM Do, YYYY')}, for ${detail.propertyAddress}, and all is valid and in good standing.`

    const formattedText = wrapText(text, 254, customFont, fontSize);

    pages[0].drawText(formattedText,
        {
            x: width - 295,
            y: height - 668,
            lineHeight: 12,
            size: fontSize,
            font: customFont,
        });
    // NY, on the date of July 31st, 2024, for 1722 45th St, Brooklyn NY 11204, and all is valid and in good standing.

    const pdfBytes = await pdfDoc.save();

    const bytes = new Uint8Array(pdfBytes);
    const blob = new Blob([bytes], { type: "application/pdf" });
    return Promise.resolve(blob);
}

export async function generateBlobShort(detail: any) {
    const fontURL = '/fonts/calibril.ttf'
    const fontBytes = await fetch(fontURL).then(res => res.arrayBuffer())

    let url = `${process.env.REACT_APP_BASE_URL}/heter-iska/power-express-short.pdf`;

    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    pdfDoc.registerFontkit(fontkit)
    const customFont = await pdfDoc.embedFont(fontBytes)

    const pages = pdfDoc.getPages();
    const fontSize = 10;

    const { height, width } = pages[0].getSize()


    const _ctcDate = detail.ctcDate ? moment(detail.ctcDate) : moment();
    pages[0].drawText(
        _ctcDate.format(constant.formatting.usDateFormat),
        {
            x: 110,
            y: height - 307,
            size: fontSize,
            font: customFont,
        });

    
    // area for borrower name + signature
    pages[0].drawRectangle({
        x: 80,
        y: height - 139,
        width: 200,
        height: 40,
        borderWidth: 0,
        color: rgb(1, 1, 1),
        opacity: 1,
    });


    pages[0].drawText(detail.borrowerName,
        {
            x: 80,
            y: height - 115,
            size: fontSize,
            font: customFont,
        });

    // borrower signature image on short form
    if (detail.borrowerSignature) {
        const pngImageBytes = await fetch(detail.borrowerSignature).then((res) => res.arrayBuffer());
        const pngImage = await pdfDoc.embedPng(pngImageBytes);
        const pngDims = pngImage.scale(0.25);
        pages[0].drawImage(pngImage, {
            x: 110,
            y: height - 391,
            width: pngDims.width,
            height: pngDims.height,
        });
 // date printed next to short-form signature (same as main PDF ctcDate)
 pages[0].drawText(
    _ctcDate.format(constant.formatting.usDateFormat),
    {
        x: 110,
        y: height - 404,
        size: fontSize,
        font: customFont,
    });
        
    }
   
    const pdfBytes = await pdfDoc.save();

    const bytes = new Uint8Array(pdfBytes);
    const blob = new Blob([bytes], { type: "application/pdf" });
    return Promise.resolve(blob);
}

export async function generateBlobs(detail: any) {
    const mainBlob = await generateBlob(detail);
    const shortBlob = await generateBlobShort(detail);
    return [mainBlob, shortBlob];
}

export default HeterIskaPDF;